import { useTranslation } from "react-i18next";
import { Spinner } from "@tellescope/design-system";

export const TwilioLoadingState = () => {
  const { t } = useTranslation("onboarding");

  return (
    <div className="flex flex-col gap-4 items-center justify-center">
      <Spinner />
      <p className="text-sm text-muted-foreground">{t("Loading...")}</p>
    </div>
  );
};
